const STORAGE_KEY = 'admin.postLoginPath';

export function safeRelativePath(raw: string | null): string | null {
  if (!raw || !raw.startsWith('/')) return null;
  let url: URL;
  try {
    url = new URL(raw, window.location.origin);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin || url.pathname === '/login') return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

export function rememberPostLoginPath(raw: string | null): void {
  const path = safeRelativePath(raw);
  try {
    if (path) {
      sessionStorage.setItem(STORAGE_KEY, path);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    return;
  }
}

export function peekPostLoginPath(): string | null {
  try {
    return safeRelativePath(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

export function clearPostLoginPath(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
}
